/**
 * Detect if running in React Native environment
 */
export function isReactNative(): boolean {
  return typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
}

/**
 * Detect if running in web environment
 */
export function isWeb(): boolean {
  return typeof window !== 'undefined' && !isReactNative();
}

/**
 * Detect if running in production environment
 */
export function isProduction(): boolean {
  if (typeof process !== 'undefined' && process.env) {
    return process.env['NODE_ENV'] === 'production';
  }
  // For browser environments, check if baseURL contains production domain
  // or if we're in a production build
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // Common production indicators
    return (
      hostname !== 'localhost' &&
      hostname !== '127.0.0.1' &&
      !hostname.includes('dev') &&
      !hostname.includes('staging')
    );
  }
  return false;
}
